/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.main[_ngcontent-%COMP%] {\n	position: relative;\n	max-width: 1400px;\n  margin: auto;\n  padding: 0 15px;\n}\n\na[_ngcontent-%COMP%] {\n  outline: none;\n}\n\nbutton[_ngcontent-%COMP%] {\n  outline: none;\n}\n\n.wrapper[_ngcontent-%COMP%] {\n  min-height: calc(100vh - 110px);\n  width: 100%;\n  max-width: 100%;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZmJvb2tpbmcvYW5ndWxhci1jbGllbnQvc3JjL2FwcC9hcHAuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2Zib29raW5nL2FuZ3VsYXItY2xpZW50L3NyYy9hcHAvYXBwLmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.component.css.shim.ngstyle.ts